<template>
  <el-container id="noticeGl">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <el-date-picker
              v-model="ediTime"
              type="daterange"
              @change="getNotice()"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-select v-model="ediOline" ref='devSonSelect'
                     @change="getNotice()"
                     clearable filterable placeholder="公告状态"
                     style="width:8vw;margin-left:5px;">
            <el-option
                v-for="item in liOline"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left:10px;height:40px;" type="primary" @click="onResh" icon="el-icon-refresh">
            重置
          </el-button>
          <span style="margin-left:auto; font-size: 13px">
            <el-input
                placeholder="搜索公告标题"
                style="width:15vw;"
                prefix-icon="el-icon-search"
                clearable
                @change="getNotice()"
                v-model="ediTitle">
            </el-input>
          </span>
          <el-button @click="onAddNotice" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:0.5vw;margin-right:0px;font-size:15px;line-height:18px">
            新增公告
          </el-button>
        </div> <!--align-items:center;justify-content:center;-->
        <div style="display:flex;height:100px;width:100%;margin-top:6px">
          <div style="display:flex;width:33%;background-color:#F4F4F4">
            <div style="width:70px;margin:20px">
              <p style="margin: 0;color: #6B7280">公告总数</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px">{{ totalCount }}</p>
            </div>
            <el-image style="width:25px;height:20px;margin-left:auto;margin-right:20px;margin-top:36px"
                      :src="notice_gg"
                      fit="fit">
            </el-image>
          </div>
          <div style="display:flex;width:34%;margin-left:5px;background-color:#F4F4F4">
            <div style="width:70px;margin:20px">
              <p style="margin:0;color: #6B7280">未发布</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px">{{ noPub }}</p>
            </div>
            <el-image style="width:25px;height:20px;margin-left:auto;margin-right:20px;margin-top:36px"
                      :src="notice_lj"
                      fit="fit">
            </el-image>
          </div>
          <div style="display:flex;width:33%;margin-left:5px;margin-right:0px;background-color:#F4F4F4">
            <div style="width:70px;margin:20px">
              <p style="margin: 0;color: #6B7280">今日发布</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px">{{ todayPub }}</p>
            </div>
            <el-image style="width:25px;height:20px;margin-left:auto;margin-right:20px;margin-top:36px"
                      :src="notice_day"
                      fit="fit">
            </el-image>
          </div>
        </div>
        <el-table :data=fil_tabData ref="table" class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:5px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="50" label="排序">
            <template slot-scope="scope">
              <i id="drag_btn" class="el-icon-s-grid" style="font-size:25px"></i>
            </template>
          </el-table-column>
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w">
            </el-table-column>
          </div>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button @click="onChangeNotice(scope.row,'r')" type="text" size="small"
                           style="color:#4B5563;font-size: 14px">查看
                </el-button>
                <el-button v-if="scope.row.state!=='未开始'&&scope.row.state!=='进行中'"
                           @click="onChangeNotice(scope.row,'w')" type="text" size="small"
                           style="color:#1677FF;font-size: 14px">编辑
                </el-button>
                <el-button v-if="scope.row.state==='未开始'||scope.row.state==='进行中'"
                           @click="upState(scope.row,1)" type="text" size="small"
                           style="color:#EAB308;font-size: 14px">下线
                </el-button>
                <el-button v-if="scope.row.state==='未开始'||scope.row.state==='进行中'"
                           @click="upState(scope.row,4)" type="text" size="small"
                           style="color:red;font-size: 14px">取消
                </el-button>
                <el-button
                    v-if="scope.row.state==='未发布'"
                    @click="upState(scope.row,2)" type="text" size="small"
                    style="color:#22C55E;font-size: 14px">发布
                </el-button>
                <el-button v-if="scope.row.state!=='未开始'&&scope.row.state!=='进行中'"
                           @click="onDelNotice(scope.row)" type="text" size="small"
                           style="color:red;font-size: 14px">删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10,20,30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDelNotice"
        width="30%">
      <span>确定删除该公告吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelNotice = false">取 消</el-button>
        <el-button type="primary" @click=delUser()>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="取消提示"
        :visible.sync="daiCleanNotice"
        width="30%">
      <span>确定取消该公告吗？ 取消后将提前结束。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiCleanNotice = false">取 消</el-button>
        <el-button type="primary" @click=cleanUser()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name:"noticeGl",
  components:{ /*引入组件*/

  },
  data() {
    return {
      h_text:"公告管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      notice_lj:require('@/assets/notice_lj.png'),
      notice_day:require('@/assets/notice_day.png'),
      notice_gg:require('@/assets/notice_gg.png'),
      scan_user:"",
      ediTime:"",
      tabData:[],
      maxHeight:window.innerHeight - 350,
      defHead:[
        {'key':"公告标题",'val':"title","w":"auto"},
        {'key':"公告时间",'val':"times1","w":"auto"},
        {'key':"操作时间",'val':"times2","w":"auto"},
        {'key':"操作人",'val':"user","w":"auto"},
        {'key':"公告状态",'val':"state","w":"auto"}
      ],
      id:1,
      stateId:1,
      ediOline:"",
      liOline:[
        {value:1,label:"未发布"},
        {value:2,label:"未开始"},
        {value:3,label:"进行中"},
        {value:4,label:"已取消"},
        {value:5,label:"已过期"}
      ],
      page:1,
      pageSize:10,
      total:0,
      noPub:0,
      todayPub:0,
      totalCount:0,
      ediTitle:"",
      li_notice:[],
      daiCleanNotice:false,
      daiDelNotice:false
    };
  },
  methods:{ /*方法存放*/
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNotice();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getNotice();
    },
    onResh() {
      this.ediTime = "";
      this.ediTitle = "";
      this.ediOline = "";
      this.getNotice();
    },
    onAddNotice() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsNoticeGlSon',
        query:{key:'addNotice'}
      });
    },
    onChangeNotice(row,operate) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsNoticeGlSon',
        query:{
          key:'changeNotice',
          id:row.id,
          operate:operate
        }
      });
    },
    getNotice() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTitle) {
        params["title"] = this.ediTitle; /*角色id*/
      }
      if (this.ediOline) {
        params["stateId"] = this.ediOline; /*发布状态*/
      }
      if (this.ediTime) {
        console.log(new Date().getTime());
        console.log(this.ediTime[0].getTime() / 1000); /*筛选时间*/
        console.log(this.ediTime[1].getTime() / 1000); /*筛选时间*/
        params['validStart'] = parseInt("" + this.ediTime[0].getTime() / 1000);
        params['validEnd'] = parseInt("" + this.ediTime[1].getTime() / 1000) + 86400; /*结尾+1天*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getNotifyList,params,headers).then(res => {
        console.log("getNotifyList：",res.data.data);
        this.li_notice = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
        this.getNotifyStatis();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取通知数据失败");
        }
      });
    },
    getNotifyStatis() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTitle) {
        params["title"] = this.ediTitle; /*角色id*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.notifyStatis,params,headers).then(res => {
        console.log("getNotifyStatis：",res.data.data);
        this.noPub = res.data.data["noPub"];
        this.todayPub = res.data.data["todayPub"];
        this.totalCount = res.data.data["totalCount"];
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取通知数据失败");
        }
      });
    },
    upState(row,stateId) {
      this.id = row.id;
      this.stateId = stateId;
      if (stateId === 4) {
        this.daiCleanNotice = true;
        return;
      }
      const params = {
        'id':row.id,
        'stateId':stateId,  /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.changeNotifyState,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.getNotice();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    cleanUser() {
      const params = {
        'id':this.id,
        'stateId':this.stateId,  /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.changeNotifyState,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("取消成功");
        this.daiCleanNotice = false;
        this.getNotice();
      }).catch(error => {
        console.log(error);
        this.daiCleanNotice = false;
        if (error) {
          this.$message.error("取消失败");
        }
      });
    },
    onDelNotice(row) {
      this.id = row.id;
      this.daiDelNotice = true;
    },
    delUser() {
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delNotify,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelNotice = false;
        if (this.total % this.pageSize === 1 && this.page !== 1) {
          this.page -= 1;
        }
        this.getNotice();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    init_View() {
      let data = this.li_notice;
      let li_d = [];
      for (let i = 0; i < data.length; i++) {
        let startT = "";
        let endT = "";
        if (data[i]['validStart'] && data[i]['validEnd']) {
          startT = this.timestampToTime(data[i]['validStart'] * 1000);
          endT = this.timestampToTime(data[i]['validEnd'] * 1000);
        }
        let d = {
          id:data[i]['id'],
          title:data[i]['title'],
          user:"",
          times1:`${startT} - ${endT}`,
          times2:this.timestampToTime(data[i]['pubTime'] * 1000),
          state:""
        };
        if (data[i]['sysUser']) {
          d.user = data[i]['sysUser']['userName'];
        }
        switch (data[i].stateId) {
          case 1:
            d.state = "未发布";
            break;
          case 2:
            d.state = "未开始";
            break;
          case 3:
            d.state = "进行中";
            break;
          case 4:
            d.state = "已取消";
            break;
          case 5:
            d.state = "已过期";
            break;
        }
        li_d.push(d);
      }
      this.tabData = li_d;
    },
    upOrder(newItem,oldItem) { /*更新轮播图排序*/
      console.log(newItem,oldItem);
      const params = {
        'srcId':this.tabData[oldItem].id,
        'destId':this.tabData[newItem].id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.exchangeNotifySort,params,headers).then(res => {
        console.log(res.data.data);
        let temp = this.tabData[oldItem];
        this.tabData[oldItem] = this.tabData[newItem];
        this.tabData[newItem] = temp;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("操作失败");
        }
        this.getNotice();
      });
    },
    rowDrop() { /*页面拖动*/
      console.log("------***------");
      const el = this.$refs.table.$el.querySelector(
          ".el-table__body-wrapper > table > tbody"
      );
      const that = this;
      Sortable.create(el,{
        animation:150,
        ghostClass:'blue-background-class',
        handle:'#drag_btn',/*需要点击某个图标拖拽的话需要吧那个图标的class写在这里*/
        onMove:function (/**Event*/evt, /**HTMLElement*/originalEvent) {
          //console.log('evt',evt);
          //console.log('dst',evt.related);
          //console.log('from',evt.dragged);
          let obj = evt.to.children;
          let dstKey = 1;
          let fromKey = 1;
          for (let key in obj) {
            if (obj[key] === evt.related) {
              dstKey = key;
              console.log("dst-key",key);
            }
            if (obj[key] === evt.dragged) {
              fromKey = key;
              console.log("from-key",key);
            }
          }
          // 仅允许移动一个位置
          if (Math.abs(dstKey - fromKey) > 1) {
            that.$message.warning("请缓慢拖动");
            return false; // 阻止该拖动操作
          } else {
            that.upOrder(dstKey,fromKey); // 更新sort
            return true;
          }
        },
        onEnd(/**Event*/evt) {
          //const currRow = that.tableData.splice(oldIndex,1)[0];
          //that.tableData.splice(newIndex,0,currRow);
          //console.log("table",that.tableData); // 获取排序后的数组
          let newIndex = evt.newIndex;  // 排序后的索引位置
          let oldIndex = evt.oldIndex;  // 排序前的索引位置
          var itemEl = evt.item;  // 拖拽 HTMLElement
          //console.log("newIndex",newIndex);
          //console.log("oldIndex",oldIndex);
          //that.upOrder(newIndex,oldIndex);
        },
        onChoose:function (/**Event*/evt) { /*点击选中元素事件*/
          evt.oldIndex;
        },
        onUnchoose:function (/**Event*/evt) { /*取消选中事件*/
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.getNotice();
    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  beforeDestroy() { /*页面结束时调用*/

  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        // if (this.edi_auth && item.authorityId !== this.edi_auth) {
        //   this.state = false
        // }
        // if (this.scan_user && !item.userName.includes(this.scan_user)) {
        //   this.state = false
        // }
        // if (this.edi_status) {
        //   if (this.edi_status.includes("启用")) {
        //     if (!item.userState) {
        //       this.state = false
        //     }
        //   } else {
        //     if (item.userState) {
        //       this.state = false
        //     }
        //   }
        // }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  }
};
</script>

<style>

#noticeGl {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 60px;
  border-radius: 5px 5px 5px 5px;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/noticeGl.vue